import Styles from './FJSetLabel.module.less';

const FJSetLabel = props => {
    const { children, text } = props;

    return (
        <div>
            <div className={Styles.title}>{text}</div>
            {children}
        </div>
    );
};

export default FJSetLabel;
